import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getAllPartiesForUser } from '../../controller/client/PartyClient';
import { IPartyForUser } from '../../PartyClientResponse';
import { getIdToken } from '../../controller/PartyDB';
import { onLogOut } from '../../firebase/firebase';
import { useAppState } from '../../state/AppState';
import Logo from '../logo/Logo';
import './lobby.scss';

const Lobby = () => {
  const { user } = useAppState();
  const history = useHistory();
  const [yourParties, setYourParties] = useState<IPartyForUser[]>([]);

  useEffect(() => {
    if (user) {
      (async () => {
        setYourParties(await getAllPartiesForUser({ idToken: await getIdToken() }));
      })();
    }
  }, [user]);

  return (
    user && (
      <div className='lobby'>
        <Logo width={450} />
        <div className='box'>
          <h2>Welcome to the Backroom</h2>
          <p>where you can watch livestreams while dancing and talking to your friends</p>
          <h3>Your parties</h3>
          <PartyList parties={yourParties} />
          <button onClick={() => history.push('/create')}>Create new party</button>
          <h3>Your account</h3>
          <p>Welcome {user.displayName || user.phoneNumber}! You are now signed-in!</p>
          <button onClick={onLogOut}>Sign off</button>
        </div>
      </div>
    )
  );
};

const PartyList = ({ parties }: { parties: IPartyForUser[] }) => {
  const history = useHistory();
  return (
    <div className='party-list'>
      {parties && parties.length > 0 ? (
        <ul>
          {parties
            .filter((p) => !!p)
            .map((e) => (
              <li key={e.key} onClick={() => history.push(`/party/${e.key}`)}>
                {e.displayName}
              </li>
            ))}
        </ul>
      ) : (
        <p>(You have no party)</p>
      )}
    </div>
  );
};

export default Lobby;
